/** SRT-style clock: HH:MM:SS[.,]mmm → seconds. Mirrors legacy parseImageBasedTrackTime. */
export function parseClockTime(str: string | null | undefined): number | null {
  if (str == null) return null;
  const regex = /^(\d+):(\d+):(\d+)[.,]?(\d+)?$/;
  const exec = regex.exec(str);
  if (exec === null) return null;

  const hours = Number(exec[1]);
  const minutes = Number(exec[2]);
  const seconds = Number(`${exec[3]}${exec[4] ? `.${exec[4]}` : ''}`);
  return hours * 3600 + minutes * 60 + seconds;
}

/** TTML tick suffix: 97597500t with tickRate → seconds. Mirrors legacy parseTextBasedTrackTime. */
export function parseTickTime(str: string | null | undefined, tickRate: number): number | null {
  if (str == null) return null;
  const regex = /^(\d+)t$/;
  const exec = regex.exec(str);
  if (exec === null) return null;
  return Number(exec[1]) / tickRate;
}

/** `525px 71px` → { h, v }. Mirrors legacy parseImageBasedTrackSize. */
export function parsePixelPair(str: string | null | undefined): { h: number; v: number } | null {
  if (!str) return null;
  const regex = /^(\d+)px\s(\d+)px$/;
  const exec = regex.exec(str);
  if (exec === null) return null;
  return { h: Number(exec[1]), v: Number(exec[2]) };
}

export function stripDirectionalityMarks(text: string): string {
  return text.replaceAll(/&lrm;|\u200E/gi, '');
}
